import { createSelector } from '@ngrx/store';
import { allowedIpRegisterSelector } from './allowed-ip-register.reducer';

export const selectFilters = createSelector(allowedIpRegisterSelector, (state) => state.filters);
